<template>
  <div class="contract" v-my-loading='loading'>
    <div v-if="this.$route.query.isApp == 1">
        <div v-if="!isLoading && linkType != 3" class="contract-header">
            <div><i @click.stop="goBack" class="iconfont icon-xiangyou" :class="[isDirection ? '' : 'mirrorRotateLevel']"></i></div>
        </div>
        <div v-if="this.$route.query.isBanner == 0 && !isLoading" class="contract-header">
            <div><i @click.stop="goBack" class="iconfont icon-xiangyou" :class="[isDirection ? '' : 'mirrorRotateLevel']"></i></div>
        </div>
    </div>
    <div class="scroll-box" :class="{isiOS:isiOS}">
      <InCompleteSiteHead v-if="this.$route.query.isApp != 1" class="InCompleteSiteHead" />
          <div class="contract-main" :style="{ 'background-image': `url(${config.h5Img})` }"></div>
      <div :class="[config.content ? 'ruleBtn' : 'noRules']">
        <!--      <van-button class="openApp bold" @click="openApp" v-if="$route.query.isApp != 1">{{ $t("300356") }}</van-button>-->
        <van-button class="RegisterNow bold" v-if="istrue === 1 &&config.state === 1 && config.endTime > new Date() * 1" @click="application">{{ $t("300352") }}</van-button>
        <!-- 立刻报名 -->
        <van-button class="registered bold" @click="activity_registration_click(2)" v-if="istrue === 2 &&config.state === 1 && config.endTime > new Date() * 1">{{ $t("300353") }}</van-button>
        <!-- 已报名 -->
        <van-button class="registered bold" v-if="config.state === 1 &&config.endTime < new Date() * 1" @click="activity_registration_click(4)">{{ $t("300354") }}</van-button>
        <!-- 报名已结束 -->
        <div class="contractCompetition" v-if="config.content">
          <div v-html="config.content"></div>
        </div>
      </div>
    </div>
    <div class="purchase-toast" v-if="buySuccess">
      <lottie class="lottie" :options="defaultOptions"></lottie>
      <p class="bold">{{ $t("300355") }}</p>
      <!-- 报名成功 -->
    </div>
  </div>
</template>

<script>
import {Button, Toast} from 'vant'
import Fingerprint2 from 'fingerprintjs2'
import onceBuy from '../../../static/animationData/one.json'
import {getActivity, findUserOperation, application} from './api'
import {mapGetters} from "vuex";
import {getLanguageList, getUserInfo} from "../../api/user";
import {setToken} from '../../utils/auth'
import InCompleteSiteHead from '../../compontents/newHome/InCompleteSiteHead.vue'
import { getBanner } from '../../api/resource'

import '@/assets/newCss/reset.scss'
import '@/assets/tailwendcss.css'
import '@/assets/uemo-icon-font/fonts/ueicon.css'
import '@/assets/newCss/var.scss'
//TODO:行高问题
import '@/assets/newCss/base.scss'

export default {
  components: {
    VanButton: Button,
    InCompleteSiteHead
  },
  data() {
    return {
      istrue: '',
      uniqueIdentification: '',
      defaultOptions: {animationData: onceBuy, loop: false},
      buySuccess: false,
      config: {},
      userInfo: {},
      languageName: '',
      cftj: false,
      loading: true,
      isLoading:true,
      isiOS: '',
      linkType:'',
    }
  },
  computed: {
    ...mapGetters(['token', 'user', 'language','isApp','isDirection'])
  },
  created() {
    // this.isWebView()
    console.log(this.$route.path, 'this.$route.path')
    console.log(this.$route.query, 'this.$route.query')
    this.getBanner()
    var u = navigator.userAgent;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if(this.$route.query.backgroundColor!=''){
      window.document.documentElement.setAttribute(
        'data-theme',
        this.$route.query.backgroundColor === 'day' ? 'sunlight' : 'moon'
      )
    }
    this.istrue = ''
    let langugage = this.$route.query.language || this.language;
    console.log(this.$route.query.language,'this.$route.query.language');
    this.$store.dispatch('setLanguage',langugage)
    getLanguageList().then(res => {
      let el = res.data.find(item => {
        return item.language == this.$route.query.language
      })
      // this.$store.dispatch('setLanguageName', el.name)
      if (this.$route.query.isApp == 1) {
        this.$i18n.locale = this.$route.query.language
      }
      this.$store.dispatch(
        "setIsDirection",
        this.$route.query.language == "fa" || this.language == 'fa' ? true : false
      );
      window.document.documentElement.setAttribute(
        "dir",
        this.isDirection ? "rtl" : "ltr"
      );
    })
    
    this.resher()
    // let token = this.$route.query.token || this.token
    // if (token) {
    //   setToken(token);
    //   this.$store.dispatch('GetInfo', token);
    //   this.$store.dispatch('setToken', token);
    //   // if (this.$route.query.isApp == 1) {
    //     getUserInfo(token).then(res => {
    //       this.userInfo = res.data
    //       findUserOperation({customId: this.$route.query.id, userId: res.data.id}).then(res => {
    //         this.istrue = res.data ? 2 : 1
    //       })
    //     })
    //   // }
    // } else {
    //   this.istrue = 1;
    // }
        const channelUrl = window.location.href;
    sessionStorage.setItem('channelUrl', channelUrl);
    console.log(window.sessionStorage.getItem('invitationCode'),'invitationCode');
    const invitationCode = window.sessionStorage.getItem('invitationCode');
    if (invitationCode && !window.location.href.includes('invitationCode=')) {
        const updatedUrl = `${window.location.href}${window.location.href.includes('?') ? '&' : '?'}invitationCode=${invitationCode}`;
        window.history.replaceState({ path: updatedUrl }, '', updatedUrl);
    }
    if(this.$route.query.isApp!=1){
      analytics.track("H5 Page Button Clicked",{
        trigger:'join_now_button'
      });
    }else{
      this.$jsBridge.callHandler(
        this.$jsBridgeCmd.segmentReport,
        {data:{url: window.location.href.toString().split('?')[0] + `?id=${this.$route.query.id}`,trigger:'h5_page_join_now_button'}},
        (data) => {}
      )
    }

    this.getActivity();
  },
  watch: {
    $route() {
      this.resher()
    },
  },
  methods: {
    isWebView() {
      try {
                    this.$jsBridge.callHandler(
                        this.$jsBridgeCmd.appLogin,
                        {
                            code: 200,
                            type: 'login',
                        },
                        (data) => {
                            console.log(data,'===第一个data的===');
                        },
                        (data) => {
                            //写去h5的登录
                            console.log(data,'===第二个data的===');
                                    
                        },
                    )
                } catch (error) {
                    console.log('===看看失败的catch===');
                }
    },
    resher(){
      this.isApp = this.$route.query.isApp
      let token = this.$route.query.token || this.token
      if (token) {
        setToken(token);
        this.$store.dispatch('GetInfo', token);
        this.$store.dispatch('setToken', token);
        // if (this.$route.query.isApp == 1) {
          getUserInfo(token).then(res => {
            this.userInfo = res.data
            findUserOperation({customId: this.$route.query.id, userId: res.data.id}).then(res => {
              this.istrue = res.data ? 2 : 1
            })
          })
        // }
      } else {
        this.istrue = 1;
      }
    },
    getBanner() {
            getBanner({ type: 2 })
                .then((res) => {
                    if (res.code === 200) {
                        this.bannerList = res.data
                        console.log(this.bannerList, 'bannerList==========')
                        const anniversaryBanner = res.data.find((item) =>
                            item.link.includes('/contractCompetition')
                        )
                        if (anniversaryBanner) {
                            this.linkType = anniversaryBanner.linkType
                            console.log(this.linkType, 'this.linkType')
                        }
                    }
                })
                .catch(() => {
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
    goBack(){
      let isApp = (this.$route.query.isApp || this.isApp) ? '&isApp=1' : ''
      this.$router.push(`/activity?language=${this.language}${isApp}&backgroundColor=`+this.$route.query.backgroundColor)
    },
    application() {
      if(this.$route.query.isApp == 1){
        this.$jsBridge.callHandler(
          this.$jsBridgeCmd.segmentReport,
          {data:{url: window.location.href.toString().split('?')[0] + `?id=${this.$route.query.id}`,trigger:'h5_page_register_now_button',userId:this.user.id || null}},
          (data) => {}
        )
      }else{
        analytics.track("H5 Page Button Clicked",{
          trigger:'h5_page_register_now_button'
        });
      }
      if (this.cftj) return;
      this.cftj = true;
      this.activity_registration_click(2);

      if (this.$route.query.token || this.token) {
        application({customId: this.$route.query.id, userId: this.userInfo.id}).then(res => {
          if (res.code == 200) {
            findUserOperation({customId: this.$route.query.id, userId: this.userInfo.id}).then(res => {
              this.istrue = res.data ? 2 : 1
            })
            this.buySuccess = true;
            let timer = setTimeout(() => {
              this.buySuccess = false;
              this.cftj = false;
            }, 1500)
          }
        })
      } else {
        this.appLogin()
        // if(this.$route.query.token){
        //   Toast('有token')
        // }else{
        //   Toast('没有token')
        //   this.appLogin()
        // }
      }
    },
    appLogin() {
      let banner = this.$route.query.isBanner == 1 ? '&isBanner=1' : '&isBanner=0'
      if (this.$route.query.isApp == 1 || this.isApp == 1) {
        this.$jsBridge.callHandler(
          this.$jsBridgeCmd.appLogin,
          {
            code: 200,
            type: "login",
            url: window.location.href.toString().split("?")[0] + `?id=${this.$route.query.id}${banner}`
          },
          data => {
          }
        );
      } else {
        this.$router.push({path: '/login', query: { historyBack: `/contractCompetition?id=${this.$route.query.id}`}});
      }
    },
    // 进入页面展示事件 activity_registration_exhibit
    activity_registration_exhibit() {
      window.gtag('event', 'activity_registration_exhibit', {
        userinfo_id: this.token ? this.userInfo.id : '',
        platform_type: this.$route.query.isApp != 1 ? 'h5' : navigator.userAgent.match(/(iPhone|iPod|iPad);?/i) ? 'ios' : navigator.userAgent.match(/android/i) ? 'android' : '',
        system_language: this.languageName,
        activity_id: this.$route.query.id
      })
    },
    // 点击按钮事件 activity_registration_click
    activity_registration_click(buttonType) {
      window.gtag('event', 'activity_registration_click', {
        userinfo_id: this.token ? this.userInfo.id : '',
        platform_type: this.$route.query.isApp != 1 ? 'h5' : navigator.userAgent.match(/(iPhone|iPod|iPad);?/i) ? 'ios' : navigator.userAgent.match(/android/i) ? 'android' : '',
        system_language: this.languageName,
        activity_id: this.$route.query.id,
        button_type: buttonType
      })
    },
    getActivity() {
      getActivity(this.$route.query.id).then(res => {
        this.loading = false;
        if (!res.data || res.data.state === 0) {
          this.$router.replace('/errorPage', '');
          return
        }
        this.config = res.data
      })
    },
    openApp() {
      this.activity_registration_click(1);
      let _this = this
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        // var loadDateTime = new Date();
        window.location.href = "superwallet://com.superex.ex";//schema链接或者universal link
        let timer = setTimeout(function () { //如果没有安装app,便会执行setTimeout跳转下载页
          // var timeOutDateTime = new Date();
          // if (timeOutDateTime - loadDateTime < 1000) {
          _this.$router.push({path: '/download', query: {type: ''}});
          clearTimeout(timer)
          // } else {
          //   window.close();
          // }
        }, 2000);
      } else if (navigator.userAgent.match(/android/i)) {

        window.location.href = 'superex://com.aliex.ex'
        window.setTimeout(() => {
          try {
            _this.$router.push({path: '/download', query: {type: ''}})
          } catch (e) {
          }
        }, 2000)

      }
    },
    getUnique() {
      let _this = this;
      let excludes = {};
      let options = {
        excludes: excludes
      }
      Fingerprint2.get(options, function (components) {
        // 参数
        const values = components.map(function (component) {
          return component.value
        });
        // 指纹
        const murmur = Fingerprint2.x64hash128(values.join(''), 31);
        // view.innerHTML += '<p class="pp">标识 : ' + murmur + '</p>';
        // sessionStorage.setItem("Finger", murmur); //存入标识值
        // console.log(murmur);
        _this.uniqueIdentification = murmur
      });
    },
  },
  mounted() {
    this.activity_registration_exhibit()
  }
}
</script>
<style lang="scss" scoped>
.contract{
  height: 100vh;
  width: 100%;
  overflow: hidden;
  position: fixed !important;
  top: 0;
  left: 0;
  box-sizing: border-box;
  .contractCompetition{
    p{
      line-height: 1.5 !important;
    }
    span, a{
      display: inline-block;
      line-height: 1.5 !important;
    }
  }
}
</style>
<style lang="scss" scoped>
@import "../../assets/css/variableName";
@import "../../style/mixin";
@import "../../assets/css/mixin";

@import '../../assets/css/variableName';
@import '../../style/mixin';
@import '../../assets/uemo-scss/scss/abstracts/_mixins.scss';
@import '../../assets/uemo-scss/scss/abstracts/_functions.scss';
@import '../../assets/newCss/reset.scss';

.contract {
  @include background_color('background-color-2');
  /deep/ .loading-model {
    background: #1c1b1e;
  }
  //background: #0e0008;
  z-index: inherit;
  .contractCompetition {
    margin: 0 auto;
    padding: torem(16);
    background: #1c1b1e;
    border: torem(1) solid rgba(255, 255, 255, 0.05);
    width: torem(343);
    box-sizing: border-box;
    border-radius: torem(8);
    >div{
      width: 100%;
      /deep/ table{
        width: 100%!important;
      }
    }
  }
  background: #0e0008;
  min-height: 100vh;
  width: 100vw;
  &-main {
    width: 100%;
    background: no-repeat 100% 100%;
    background-size: 100% 100%;
    height: torem(430);
    padding-top: torem(44);
  }
  .ruleBtn {
    width: torem(343);
    margin: 0 auto;
    height: auto;
    /deep/ .van-button {
      background-size: 100% 100% !important;
      border: none;
      height: torem(48);
      width: torem(200);
      margin: torem(24) auto;
      display: block;
      font-size: torem(16);
      color: #000922;
    }
  }
  .noRules {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: torem(32);

    /deep/ .van-button {
      background-size: 100% 100% !important;
      border: none;
      height: torem(48);
      width: torem(200);
      margin: 0 auto;
      display: block;
      font-size: torem(16);
      color: #000922;
    }
  }
  .openApp,
  .RegisterNow {
    background: url("../../../static/images/enroll.png") no-repeat;
  }

  .registered {
    background: url("../../../static/images/registered.png") no-repeat;
  }
}
.purchase-toast {
  padding: torem(8) torem(32) torem(48) torem(32);
  box-sizing: border-box;
  p {
    color: #fff;
    font-size: torem(16);
    line-height: torem(18);
    margin-top: torem(14);
    width: 100%;
    text-align: center;
  }
  > div {
    width: torem(60) !important;
    height: torem(60) !important;
  }
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 9999;
  transform: translate(-50%, -50%);
  width: torem(197);
  height: torem(143);
  border-radius: torem(8);
  background: rgba($color: #000000, $alpha: 0.8);
}
.contract-header{
  padding: 0 torem(16);
  width: 100%;
  box-sizing: border-box;
  height: torem(44);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: fixed;
  top: 0;
  @include background_color('background-color-2');
  //background: #fff;
  left: 0;
  z-index: 9999;
  i{
    font-size: torem(18);
    width: torem(14);
    height: torem(18);
    @include font_color('font-color');
    display: inline-block;
  }
}
.scroll-box{
  //minheight: 100vh;
  height:100vh;
  overflow-y: auto;
  background: #0e0008;
  //margin-top: torem(44);
  padding: torem(44) 0;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}
.isiOS{
  //height:calc(100vh - #{torem(44)})!important;
  padding-bottom: torem(120);
}

</style>



// WEBPACK FOOTER //
// src/view/contractCompetition/index.vue